module.exports = __webpack_public_path__ + "img/Picture 4-1.8d8a699f.png";